<template>
  <base-modal
    :closeable-from-outside="false"
    hide-footer
    :size="'lg'"
    :modal-id="'generate-report-custom'"
    @hidden="$bvModal.hide('generate-report')"
    @show="() => {}"
  >
    <template>
      <div class="head-label">
        Generate Filters
      </div>
    </template>
    <div class="d-flex align-items-center flex-column mt-1">
      <b-row class="d-flex align-items-end w-100">
        <b-col v-if="customDataObj && customDataObj.statusOption.length > 1">
          <div>
            <label class="font-medium-4 required">Select Report</label>
            <v-select
              v-model="form.status"
              class="v-select-filter v-select-filter-custom mr-2 bg-dropdown font-medium-5"
              :class="form.status ? 'v-select-filter-selected' : null"
              placeholder="Select Report"
              :options="customDataObj.statusOption"
              :reduce="(option) => option.value"
              @input="
                $emit('onSelectReportCategory', {
                  status: $event,
                  isFetchList: false,
                })
              "
              :clearable="false"
            />
          </div>
        </b-col>
      </b-row>
      <b-row class="d-flex align-items-center w-100">
        <b-col
          v-for="field in filterOption.payload"
          :key="`row-${field.seq}`"
          :cols="12"
          :sm="field.field_property.half_size ? 6 : 12"
        >
          <component
            :ref="`${field.key}`"
            :is="resolveFields(field)"
            :fieldProperties="field"
            :key="field.key"
          />
        </b-col>
      </b-row>
    </div>
    <div class="flashdeal-privilege-btn-wrp">
      <div class="privilege-btn-wrp mt-2 mb-2">
        <div class="d-flex justify-content-center">
          <cancel-button
            class="mr-1"
            @click.native="$emit('onCloseGenerateReportModal')"
          />
          <save-button
            :btnLabel="'Generate'"
            :type="'submit'"
            class="ml-1"
            @click.native="onSubmit"
            :disabled="
              (form.status == null && form.status == undefined) ||
                loading.btnReport
            "
          />
          <b-spinner v-if="loading.btnReport" small class="ml-1" />
        </div>
      </div>
    </div>
  </base-modal>
</template>

<script>
import useGenerateReportModal from "../hooks/useGenerateReportModal";
import flatPickr from "vue-flatpickr-component";
import CalendarPickerIcon from "@/@core/components/svg/common/CalendarPicker.vue";
import ClockPickerIcon from "@/@core/components/svg/common/ClockPicker.vue";
import vSelect from "vue-select";

import FilterIcon from "@/@core/components/svg/common/Filter.vue";
import Toggle from "@/views/components/dynamic-fields/components/ToggleFields.vue";
import Textbox from "@/views/components/dynamic-fields/components/TextBoxField.vue";
import TextAreaField from "@/views/components/dynamic-fields/components/TextAreaField.vue";
import Dropdown from "@/views/components/dynamic-fields/components/DropdownField.vue";
import DatePicker from "@/views/components/dynamic-fields/components/DatePickerField.vue";
import PaginationWithReorder from "@/views/components/pagination/PaginationWithReorder.vue";
import OverlayLoading from "@/views/components/loading/OverlayLoading.vue";

export default {
  components: {
    flatPickr,
    CalendarPickerIcon,
    ClockPickerIcon,
    vSelect,
    FilterIcon,
    Toggle,
    Textbox,
    TextAreaField,
    Dropdown,
    DatePicker,
    PaginationWithReorder,
    OverlayLoading,
  },
  props: {
    customDataObj: null,
  },
  setup(props) {
    const {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      resolveDateString,
      resolveDateObject,
      form,
      loading,
      filterOption,
      resolveFields,
      onSubmit,
      isFilter,
    } = useGenerateReportModal(props);

    return {
      validFrom,
      validThrough,
      flatpickrDateConfig,
      flatpickrTimeConfig,
      onOpenValidFromDatePicker,
      onOpenValidFromTimePicker,
      onOpenValidThroughTimePicker,
      onSelectValidFromDate,
      onSelectValidFromTimePicker,
      resolveDateString,
      resolveDateObject,
      form,
      loading,
      filterOption,
      resolveFields,
      onSubmit,
      isFilter,
    };
  },
};
</script>

<style scoped>
.v-select-filter {
  min-width: 100% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>

<style>
@import "~@/assets/css/pages/default-static-table.css";
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";
@import "~@/assets/css/pages/data-management.css";

#generate-report-custom .modal-header {
  display: none;
}

#generate-report-custom .modal-content {
  border-radius: 1.6rem;
}

#generate-report-custom .head-label {
  font-size: 36px;
  width: 100%;
  color: #000080;
}

#generate-report-custom .head-label {
  border-bottom: 1px solid #dedede;
}

@media (min-width: 767px) {
  #generate-report-custom .modal-lg {
    max-width: 450px;
  }
}

@media (min-width: 400px) {
  #generate-report-custom .modal-lg {
    max-width: 450px;
  }
}
</style>
